/**
 * Joyride steps for the Show / Hide Columns dialog.
 */
export function buildColumnPickerTourSteps(formatMessage) {
  return [
    {
      target: '[data-tour="column-select-all"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP1_TITLE',
        defaultMessage: 'Choose columns',
      }),
      content: `${formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP1_DESC',
        defaultMessage:
          'Check a column to show it in the list. Uncheck to hide it.',
      })} ${formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_NOTE',
        defaultMessage: 'At least one column must stay visible.',
      })}`,
      disableBeacon: true,
      placement: 'bottom',
    },
    {
      target: '[data-tour="column-first-row"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP1_TITLE',
        defaultMessage: 'Choose columns',
      }),
      content: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP1_DESC',
        defaultMessage:
          'Check a column to show it in the list. Uncheck to hide it.',
      }),
      placement: 'bottom',
    },
    {
      target: '[data-tour="column-first-drag"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP2_TITLE',
        defaultMessage: 'Set order',
      }),
      content: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP2_DESC',
        defaultMessage:
          'Drag the handle or use the arrows to change column order.',
      }),
      placement: 'right',
    },
    {
      target: '[data-tour="column-first-arrows"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP2_TITLE',
        defaultMessage: 'Set order',
      }),
      content: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_GUIDE_STEP2_DESC',
        defaultMessage:
          'Drag the handle or use the arrows to change column order.',
      }),
      placement: 'left',
    },
    {
      target: '[data-tour="column-save"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_TOUR_SAVE_TITLE',
        defaultMessage: 'Save changes',
      }),
      content: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_TOUR_SAVE_DESC',
        defaultMessage: 'Save to update the list with this column layout.',
      }),
      placement: 'top',
    },
    {
      target: '[data-tour="column-reset"]',
      title: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_TOUR_RESET_TITLE',
        defaultMessage: 'Reset to default',
      }),
      content: formatMessage({
        id: 'SHOW_HIDE_COLUMNS_TOUR_RESET_DESC',
        defaultMessage:
          'Reset to default restores the original column layout and selection.',
      }),
      placement: 'top',
    },
  ];
}

export default buildColumnPickerTourSteps;
